<template>
  <div>
    <component :is="component" :data="templateData" v-if="component"/>
    <!-- <template2 :data="templateData"></template2> -->
  </div>
</template>
<script>
export default {
  name: "post",
  async mounted() {
    await this.load();
  },
  data() {
    return {
      component: null,
      type: "",
      templateData: {
        postEntry: null,
        images: []
      }
    };
  },
  watch: {
    async "$route.params.postName"(oldParam, newParam) {
      await this.load();
    }
  },
  computed: {
    loader: function() {
      if (!this.type) {
        return null;
      }
      return () => import(`./Templates/${this.type}`);
    }
  },
  methods: {
    load: async function() {
      await this.loadNoticia();
      await this.loadCarousel();

      let templateName = this.templateData.postEntry.templateUri;
      templateName =
        templateName.charAt(0).toUpperCase() + templateName.slice(1); // Pasando 1era letra a UpperCase

      this.type = templateName; // Ejemplo: 'Template2';
      if ((await this.loader()) != null) {
        this.component = () => this.loader();
      } else {
        this.component = () => import("./Templates/Template2"); //default
      }
    },
    loadNoticia: async function() {
      var uuid = this.getUuid();
      try {
        let response = await this.$zaiq().get("Noticia/GetByUuid", {
          params: { uuid }
        });

        this.templateData.postEntry = response.data.result;
      } catch (e) {
        if (this.vErrors) this.vErrors.items.push(e);
        console.log(e);
      }
    },
    loadCarousel: async function() {
      try {
        var uuid = this.getUuid();

        let response2 = await this.$zaiq().get("ImagenPorPostEntry/GetByUuid", {
          params: { uuid }
        });
        var myArray = [];
        let list = response2.data.result.items;

        var urlBaseImage = process.env.VUE_APP_API_BASE + "uploads/" + uuid;
        list.map(function(item) {
          item.src = urlBaseImage + "/" + item.nombre;
          myArray.push(item);
        });

        this.templateData.images = myArray;
      } catch (e) {
        if (this.vErrors) this.vErrors.items.push(e);
        console.log(e);
      }
    },
    getUuid: function() {
      return this.$route.params.postName;
    }
  }
};
</script>
<style>
div.section {
  padding-bottom: 0;
}
</style>
